import React from 'react';
import { reduxForm, } from 'redux-form';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router';
import Card from '../../Components/Card/Card'
import CardHeader from '../../Components/Card/CardHeader'
import CardBody from '../../Components/Card/CardBody'
import { Show } from 'Layout';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import { Card as Card2, CardHeader as CardHeader2, CardContent } from '@material-ui/core';
import { PageStatus } from 'enums';
import GridContainer from "../Grid/GridContainer";
import { ProfileManagementAPI } from "../../API/ProfileManagementAPI";
import { connect } from "react-redux";
import { Confirmation } from "../../Shared/Confirmation";
import { AuthAPI } from "../../API";
import { ChangePasswordForm } from "./ChangePassword";
import { BasicProfile } from "./BasicProfile";
import VerifiedNumber from "./VerifiedNumber";
import { settingDict, formFieldDict } from 'Languages/SettingTranslations';
import { PORTAL_CODE } from '../../config/portalBranding';
import { withTranslation } from "react-i18next";
// Imported as countryConfig (not `country`) to avoid shadowing by the
// `.then((country) => …)` callback params used elsewhere in this file.
import countryConfig from 'config/countryConfig';

const IS_JAPAN_PORTAL = PORTAL_CODE === 'JP';

export type FormValue = {
    "name": string,
};

type State = {
    status: string,
    error: string | null,
    country: any,
    name: string,
};


const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
};

class MySettings extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            formType: MODAL_TYPES.NONE,
            error: null,
            data: null,
            showMobileVerification: false,
            userResponse: {},
        };
    }

    componentDidMount() {
        if (this.props.userId) {
            this.fetchDetails();
        }
    }

    handleClick = (type) => {
        switch (type) {
            case 'About':
                this.props.history.push('/panelist/about');
                break
            case 'Personal Finance':
                this.props.history.push('/panelist/personal-finance');
                break
            case 'Shopping':
                this.props.history.push('/panelist/shopping');
                break
            case 'Travel':
                this.props.history.push('/panelist/travels');
                break
            case 'Leisure & Activity':
                this.props.history.push('/panelist/Leisure-activity');
                break
            case 'Media':
                this.props.history.push('/panelist/media');
                break
            case 'Household':
                this.props.history.push('/panelist/household');
                break
            case 'Health & Wellness':
                this.props.history.push('/panelist/health-wellness');
                break
            case 'Professional':
                this.props.history.push('/panelist/professionals');
                break
            case 'Electronics':
                this.props.history.push('/panelist/electronics');
                break
            case 'Smokers':
                this.props.history.push('/panelist/smokers');
                break
            case 'Auto':
                this.props.history.push('/panelist/auto');
                break
            case 'Food and Beverage':
                this.props.history.push('/panelist/food-beverage');
                break;
            default:
                this.props.history.push('/panelist/about');
                break
        }
    };

    fetchDetails() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => ProfileManagementAPI.respondentProfileOverview(this.props.userId))
            .then((data) => {
                this.setState({
                    data,
                    status: PageStatus.Loaded,
                });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    onSubscribe() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.state.data?.basicProfile?.userId) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return AuthAPI.UnSubscribeUser(this.state.data?.basicProfile?.userId);
            })
            .then((country) => {
                this.fetchDetails()
                alert(this.state.data?.users?.unsubscribeDate !== null
                    ? this.props.t('settings.subscribeBrandSuccessAlert', { brand: countryConfig.brandName })
                    : this.props.t('settings.unsubscribeBrandSuccessAlert', { brand: countryConfig.brandName }))
                this.setState({ status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }


    onDeletion() {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => {
                if (!this.state.data?.basicProfile?.userId) {
                    return Promise.reject(new Error('Invalid ID'));
                }
                return AuthAPI.requestForDelete(this.state.data?.basicProfile?.userId);
            })
            .then((country) => {
                this.fetchDetails()
                alert(this.props.t('settings.deletionRequestSentAlertBatch4'))
                this.setState({ status: PageStatus.Loaded });
            })
            .catch((error) => {
                this.setState({ status: PageStatus.Error, error: error.message });
            });
    }

    render() {
        const { t } = this.props;
        const lang = this.props.language ?? 'en';
        const notCompletedStyle = { backgroundColor: '#FFFFE0', color: 'black', fontSize: '12px', marginTop: '10px' };
        return (
            <>
                <GridContainer>
                    <Card>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>{t('settings.account')}</h4>
                                <div>
                                    <Button
                                        onClick={() => this.setState({ formType: MODAL_TYPES.CHANGE_PASSWORD })}
                                        variant="primary"
                                        size="sm"
                                        className="mx-1"
                                    >
                                        {t('common.changePassword')}
                                    </Button>
                                    <Button
                                        onClick={() => this.setState({ formType: MODAL_TYPES.UPDATE })}
                                        variant="success"
                                        size="sm"
                                        className="mx-1"
                                    >
                                        {t('settings.editAccount')}
                                    </Button>
                                    {/* <Confirmation onAction={() => this.onSubscribe()} body={`${this.state.data?.users?.unsubscribeDate === null ? settingDict[lang]["Unsubscribe Confirmation"] || "Are you sure want to unsubscribe from DX Panel?" : settingDict[lang]["Subscribe Confirmation"] || 'Are you sure want to Subscribe DX Panel?'}`} >
                                        <Button
                                            variant="warning"
                                            size="sm"
                                            className="mx-1"
                                        >
                                            {`${this.state.data?.users?.unsubscribeDate ? settingDict[lang]["Subscribe Indiapolls"] || "Subscribe DX Panel" : settingDict[lang]["Unsubscribe From Indiapolls"] || 'Unsubscribe From DX Panel'}`}
                                        </Button>
                                    </Confirmation> */}
                                    {/* <Confirmation onAction={() => this.onDeletion()} body={t('settings.deletionConfirmation')}>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            disabled={this.state.data?.users?.deleteRequestDate}
                                            className="mx-1"
                                        >
                                            {t('settings.requestDeletionOfAccount')}
                                        </Button>
                                    </Confirmation> */}
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                </GridContainer>

                <Show when={this.state.status === PageStatus.Loading}>
                    <div className="d-flex justify-content-center w-100 p-5">
                        <Spinner animation="border" variant="primary" />
                    </div>
                </Show>

                <Show when={this.state.status === PageStatus.Loaded || this.state.status === PageStatus.Submitted}>
                    <Show when={this.state.formType === MODAL_TYPES.CHANGE_PASSWORD} >
                        <ChangePasswordForm
                            id={this.state.data?.basicProfile?.userId}
                            show={this.state.formType === MODAL_TYPES.CHANGE_PASSWORD}
                            title={t('common.changePassword')}  // Hypothetical example
                            onClose={() => this.setState({ formType: MODAL_TYPES.NONE })}
                            onSubmit={() => this.setState({ formType: MODAL_TYPES.NONE })}
                            language={lang}
                        />
                    </Show>

                    <Show when={this.state.formType === MODAL_TYPES.UPDATE} >
                        <BasicProfile
                            userId={this.state.data?.basicProfile?.userId}
                            show={this.state.formType === MODAL_TYPES.UPDATE}
                            title={t('settings.editAccount')}  // Hypothetical example
                            onClose={() => this.setState({ formType: MODAL_TYPES.NONE })}
                            onSubmit={() => {
                                this.fetchDetails();
                                this.setState({ formType: MODAL_TYPES.NONE })
                            }}
                            language={lang}
                        />
                    </Show>

                    <Show when={this.state.showMobileVerification} >
                        <VerifiedNumber
                            userId={this.state.data?.basicProfile?.userId}
                            phoneNumber={this.state.data?.users?.phoneNumber}
                            show={this.state.showMobileVerification}
                            title={t('settings.verifyMobileNumberTitle')}  // Hypothetical example
                            onClose={() => this.setState({ showMobileVerification: false })}
                            onSubmit={() => {
                                this.fetchDetails();
                                this.setState({ showMobileVerification: false })
                            }}
                        />
                    </Show>
                </Show>


                <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                    {this.state.error}
                </Alert>

                <Show when={this.state.status === PageStatus.Loaded || this.state.status === PageStatus.Submitted}>
                    <div className="jumbotron bg-white p-3 border shadow-sm">
                        <h2>
                            {`${this.state.data?.basicProfile?.firstName || ''} ${this.state.data?.basicProfile?.lastName || ''}`}
                        </h2>
                        <div className="mb-3">
                            <strong>{t('common.gender')}: </strong>
                            {this.state.data?.basicProfile?.gender}
                        </div>
                        {/* Mobile row hidden for JP — NipponPolls profiles no longer collect mobile (bug #3). */}
                        {!IS_JAPAN_PORTAL && (
                        <div className="mb-3">
                            <strong>{t('common.mobileLabel')}: </strong>
                            {this.state.data?.basicProfile?.mobile}
                            {this.state.data?.users?.phoneNumberConfirmed && this.state.data?.basicProfile?.mobile ?
                                (<span style={{ color: 'green', marginLeft: '5px' }}>✅ ({t('settings.verified')})</span>) :
                                (<span
                                    style={{ color: 'red', marginLeft: '5px' }}>
                                    ❌ ({t('settings.notVerified')}) <button onClick={() => this.setState({ showMobileVerification: true })} className="font-weight-bold ql-color-green bg-transparent">{t('settings.verifyQuestion')}</button>
                                </span>)
                            }
                        </div>
                        )}
                        <div className="mb-3">
                            <strong>{t('common.emailLabel')}: </strong>
                            {this.state.data?.users?.email}
                            {this.state.data?.users?.emailConfirmed && this.state.data?.users?.email ?
                                (<span style={{ color: 'green', marginLeft: '5px' }}>✅ ({t('settings.verified')})</span>) :
                                (<span style={{ color: 'red', marginLeft: '5px' }}>❌ ({t('settings.notVerified')})</span>)
                            }
                        </div>
                        <div className="mb-3">
                            <strong>{t('settings.dob')}: </strong>
                            {this.state.data?.basicProfile?.dateOfBirth}
                        </div>
                        <div className="mb-3">
                            <strong>{t('settings.address')}: </strong>
                            {this.state.data?.basicProfile?.addressLine1}
                        </div>
                        <div className="mb-3">
                            <strong>{t('settings.pinCode')}: </strong>
                            {this.state.data?.basicProfile?.pinCode}
                        </div>
                        <div className="mb-3">
                            <strong>{t('common.countryLabel')}: </strong>
                            {this.state.data?.basicProfile?.country}
                        </div>
                        <div className="mb-3">
                            <strong>{t('common.state')}: </strong>
                            {this.state.data?.basicProfile?.state}
                        </div>
                        <div className="mb-3">
                            <strong>{t('settings.city')}: </strong>
                            {this.state.data?.basicProfile?.city}
                        </div>
                    </div>

                    <Card>
                        <CardHeader color="info">
                            <div className="d-flex align-items-center justify-content-between">

                            </div>
                        </CardHeader>
                        <CardBody>
                            <Grid container spacing={5}>
                                {
                                    this.state.data?.result.map((data, index) => (
                                        <Grid item xs={12} sm={6} key={"result" + index}>
                                            <Card2>
                                                <CardHeader2
                                                    title={<>
                                                        {/* 'hi' (India) and 'jp' (Japan) both read the localized
                                                            `hindi` field — the backend `field:`-aliases it to the
                                                            country's localization column ('hindi' or 'japanese').
                                                            Fall back to the English name when it's missing. */}
                                                        {(this.props.language === 'hi' || this.props.language === 'jp')
                                                            ? (data.hindi || data.name)
                                                            : data.name}
                                                        <Chip
                                                            label={data.attemptedPercentage > 0 ?
                                                                `${Math.min(100, Math.max(0, parseInt(data.attemptedPercentage || 0, 10)))}% ${t('common.completedChip')}` :
                                                                t('settings.notStartedChip')}
                                                            style={{ marginLeft: '8px' }} // Adjust styling as needed
                                                        />
                                                    </>}
                                                    titleTypographyProps={{ style: { fontSize: '16px' } }}
                                                    style={{ background: '#454545', color: 'white' }}
                                                    action={
                                                        <Chip
                                                            label={
                                                                <button className="btn-white" onClick={() => this.handleClick(data.name)}>
                                                                    <span>{t('settings.updateAction')}</span>
                                                                </button>
                                                            }
                                                            style={notCompletedStyle}
                                                        />
                                                    }
                                                />
                                                <CardContent>
                                                    {/*<img*/}
                                                    {/*    src={"https://picsum.photos/400/"+Math.round((140+index))}*/}
                                                    {/*    alt="Full Size Image"*/}
                                                    {/*    style={{ width: '100%', height: 'auto' }}*/}
                                                    {/*/>*/}
                                                    {data.image && <img
                                                        src={`${process.env.REACT_APP_BASE_URL_API}${data.image}`}
                                                        alt="FullSizeImage"
                                                        style={{ width: '100%', height: '300px' }}
                                                        onError={(e: any) => { e.target.style.display = 'none'; }}
                                                    />}
                                                </CardContent>
                                            </Card2>
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </CardBody>
                    </Card>
                </Show>
            </>
        );
    }
}

const MySettingsRedux = reduxForm<FormValue, any>({
    form: 'MySettings',
})(withTranslation()(MySettings));

const mapStateToProps = (state: { adminUser: { adminUser: { phoneNumber: any, email: any, userId: any; token: any; loading: any; error: any; role: any, language: any }; }; }) => {
    return {
        userId: state.adminUser.adminUser.userId,
        role: state.adminUser.adminUser.role,
        phoneNumber: state.adminUser.adminUser.phoneNumber,
        email: state.adminUser.adminUser.email,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
        language: state.adminUser.adminUser.language,
    };
};

const MySettingsWithRouter = withRouter(connect(mapStateToProps)(MySettingsRedux));

export { MySettingsWithRouter as MySettings };
